import React from 'react';
import { drop } from 'lodash';
import ArticleList from './ArticleList.jsx';
import FeaturedItem from './FeaturedItem.jsx';
import RowWithTwo from './RowWithTwo.jsx';

const DualNews = ({ articles, country, showCompetitionName }) => (
  <ArticleList articles={drop(articles, 6)}>
    <FeaturedItem contentContainer={articles[0]} country={country} showCompetitionName={showCompetitionName} />
    <RowWithTwo articles={[articles[1], articles[2]]} className="featured-news" />
    <FeaturedItem contentContainer={articles[3]} country={country} showCompetitionName={showCompetitionName} />
    <RowWithTwo articles={[articles[4], articles[5]]} className="featured-news"/>
  </ArticleList>
);

export default DualNews;



// WEBPACK FOOTER //
// ./src/component/NewsFeed/DualNews.jsx